import React from "react";
import "./Surrounding.scss";
import aeon from "../../Media/Surrounding/Akses Tol.webp";
import prasmul from "../../Media/Surrounding/Al Azhar School.webp";
import binus from "../../Media/Surrounding/Gowet.webp";
import breeze from "../../Media/Surrounding/Hermina Hospital.webp";
import qbig from "../../Media/Surrounding/Living World Mall.webp";
import eka from "../../Media/Surrounding/Ipeka School.webp";
import tol from "../../Media/Surrounding/Starbucks.webp";
import sekolah from "../../Media/Surrounding/Surrounding GW.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Surrounding = () => {
  const slides = [
    {src: aeon, des: "Toll Access"},
    {src: prasmul, des: "Al-Azhar School"},
    {src: binus, des: "Go! Wet"},
    {src: breeze, des: "Hermina Hospital"},
    {src: qbig, des: "Living World Mall"},
    {src: eka, des: "Ipeka School"},
    {src: tol, des: "Starbucks"},
    {src: sekolah, des: "Mc Donald"},
  ];
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    lazyLoad: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div id="surrounding" className="surroundingcontainer">
      <div className="title">Surrounding Area</div>
      <div className="content">
        {slides.map((slide, index) => (
          <div className="center" key={index}>
            <img className="imgcontent" src={slide.src} alt="Surrounding" />
            <div className="imgdes">
              <span>{slide.des}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="content1">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div className="center" key={index}>
              <img className="imgcontent" src={slide.src} alt="Surrounding" />
              <div className="imgdes">
                <span>{slide.des}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Surrounding;
